import axios from 'axios'
import store from '@/store'

// default our apiUrl for tests
const apiUrl = window.config ? window.config.alldataHost : ''

// axios global requests
axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.getters['alldata/token']
    config.withCredentials = true
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// axios global response
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (apiUrl !== '') {
      console.debug(`Error Message from interceptor (${apiUrl}): ${error.message}`, error)
    }
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      store.getters['alldata/token']
    ) {
      store.dispatch('alldata/clearToken')
    }
    return Promise.reject(error)
  }
)

// export axios common base instance (resource: https://goo.gl/sDN0IN)
export default {
  auth: async (endpoint, credentials) => {
    const data = new URLSearchParams()
    data.append('grant_type', 'client_credentials')
    data.append('scope', 'read')
    return axios({
      url: `${apiUrl}/ADAG/oauth/token`,
      method: 'POST',
      auth: {
        username: credentials.clientid,
        password: credentials.secret
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data,
      withCredentials: true
    })
  },
  // get2: async (endpoint, data = {}, config = {}, host = apiUrl) => {
  //   return axios({
  //     url: `${host}/${endpoint}`,
  //     method: 'GET',
  //     headers: {
  //       'Accept': 'application/json',
  //       'Authorization': `Bearer ${store.getters['alldata/token']}`
  //     },
  //     withCredentials: true
  //   })
  // },
  get: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.get(`${host}/${endpoint}`, config)
  },
  put: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.put(`${host}/${endpoint}`, data, config)
  },
  post: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.post(`${host}/${endpoint}`, data, config)
  },
  delete: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.delete(`${host}/${endpoint}`, data, config)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/alldata.js